/* Measurement only. No field values, email, Klaviyo metadata or answers. */
(function () {
  'use strict';
  if (window.WynchBlockAnalyticsV1) return;
  window.WynchBlockAnalyticsV1 = { version: 1 };
  var key = 'wynch_block_sessions_v2', ctaKey = 'wynch_block_quiz_v1';
  var sessions = {}, pending = {}, chains = {}, observed = new WeakSet();
  var popupIds = new Set(), observer;
  function allowed() { return !!(window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.analyticsProcessingAllowed()); }
  function read() { try { return JSON.parse(localStorage.getItem(key) || '{}'); } catch (_) { return {}; } }
  function save() { if (allowed()) try { localStorage.setItem(key, JSON.stringify(sessions)); } catch (_) {} }
  async function session(id, instance, continuation) {
    if (!allowed()) return null;
    var slot = id + ':' + instance, saved = sessions[slot];
    if (saved && Date.now() - saved.start < ((continuation || (id.indexOf('club-') === 0 && saved.sent.indexOf('submitted') >= 0 && saved.sent.indexOf('confirmed') < 0)) ? 86400000 : 1800000)) return saved;
    if (continuation) return null;
    if (pending[slot]) return pending[slot];
    pending[slot] = (async function () {
      try {
        var response = await fetch(Shopify.routes.root + 'apps/wynch-email/block-session', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ version: 2, block: id, device: (/Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) ? 'mobile' : 'desktop') }), signal: AbortSignal.timeout(4000) });
        if (!response.ok || !allowed()) return null;
        var value = await response.json();
        if (value.block !== id || typeof value.token !== 'string' || !Number.isFinite(value.start)) return null;
        sessions[slot] = { token: value.token, start: value.start, sent: [] }; save(); return sessions[slot];
      } catch (_) { return null; }
    })();
    try { return await pending[slot]; } finally { delete pending[slot]; }
  }
  function publish(value, stage) {
    if (!allowed() || !value || value.sent.indexOf(stage) >= 0 || !Shopify.analytics || typeof Shopify.analytics.publish !== 'function') return;
    Shopify.analytics.publish('wynch_block_v1', { version: 1, token: value.token, stage: stage });
    value.sent.push(stage); save();
  }
  function emit(id, instance, stage) {
    var slot = id + ':' + instance;
    chains[slot] = (chains[slot] || Promise.resolve()).then(async function () {
      var value = await session(id, instance, stage !== 'shown');
      // A confirmed existing subscriber is not a new signup conversion.
      if (stage === 'confirmed' && (!value || value.sent.indexOf('submitted') < 0)) return;
      publish(value, stage);
    }).catch(function () {});
    return chains[slot];
  }
  function variant(node) {
    var art = node.dataset.artDirectionResolved;
    return ['illustrations', 'people'].indexOf(art) >= 0 ? 'club-' + art : '';
  }
  function target(link) {
    try {
      var url = new URL(link.href, location.href);
      var match = url.pathname.match(/\/(?:pages)\/(quiz|varlamov|demo-store-x-wynch|quiz-sugarshape)\/?$/);
      return url.origin === location.origin && match ? match[1] : '';
    } catch (_) { return ''; }
  }
  function visible(node) {
    if (document.visibilityState !== 'visible') return false;
    for (var el = node; el && el.nodeType === 1; el = el.parentElement) {
      if (el.hidden || el.hasAttribute('x-cloak') || getComputedStyle(el).display === 'none' || getComputedStyle(el).visibility === 'hidden') return false;
    }
    return true;
  }
  function discover() {
    if (!allowed()) return;
    if (!observer) { start(); return; }
    document.querySelectorAll('[data-wynch-article-club-native], a[id^="qa-section-heading-with-image-link-"]').forEach(function (node) {
      if (observed.has(node)) return;
      var id = node.matches('[data-wynch-article-club-native]') ? variant(node) : (target(node) ? 'quiz-cta' : '');
      if (!id) return;
      observed.add(node); observer.observe(node);
      if (id === 'quiz-cta') node.addEventListener('click', function (event) {
        if (!allowed() || event.button > 0) return;
        var value = sessions['quiz-cta:' + target(node)];
        if (!value || Date.now() - value.start > 1800000) return;
        publish(value, 'clicked');
        try { sessionStorage.setItem(ctaKey, JSON.stringify({ target: target(node), token: value.token, start: value.start, sent: value.sent })); } catch (_) {}
      }, true);
    });
  }
  function quizProgress(stage) {
    if (!allowed()) return;
    try {
      var value = JSON.parse(sessionStorage.getItem(ctaKey) || 'null');
      if (!value || Date.now() - value.start > 86400000 || !location.pathname.match(new RegExp('/pages/' + value.target + '/?$'))) return;
      var root = document.querySelector('.quiz-page');
      if (!root || !visible(root)) return;
      publish(value, 'landed');
      if (Array.from(root.querySelectorAll('.quiz-page-question')).some(visible)) { publish(value, 'started'); if (window.WynchJourneysV1) window.WynchJourneysV1.quizProgress('quiz_started'); }
      if (stage === 'finished') {
        publish(value, 'finished');
        if (window.WynchJourneysV1) window.WynchJourneysV1.quizProgress('quiz_finished');
        if (window.WynchCommerceAnalyticsV2) window.WynchCommerceAnalyticsV2.activate('block', { token: value.token, start: value.start });
      }
      sessionStorage.setItem(ctaKey, JSON.stringify(value));
    } catch (_) {}
  }
  document.addEventListener('wynch:article-club-native', function (event) {
    if (!allowed()) return;
    var detail = event.detail || {}, id = 'club-' + detail.artDirection;
    if (['club-illustrations', 'club-people'].indexOf(id) < 0) return;
    if (detail.event === 'native-email-form-revealed') emit(id, '', 'opened');
    if (detail.event === 'native-subscription-submitted') {
      emit(id, '', 'submitted');
      if (detail.state === 'confirmed') emit(id, '', 'confirmed');
    }
    if (detail.event === 'native-club-state' && detail.state === 'confirmed') {
      // Continue the original visual variant even if the returning page selects another.
      var sources = ['club-illustrations', 'club-people'].filter(function (source) { var value = sessions[source + ':']; return value && value.sent.indexOf('submitted') >= 0; }).sort(function (a, b) { return sessions[b + ':'].start - sessions[a + ':'].start; });
      if (sources[0]) emit(sources[0], '', 'confirmed');
    }
    discover();
  });
  window.addEventListener('klaviyoForms', function (event) {
    if (!allowed()) return;
    var detail = event.detail || {}, id = detail.formId;
    if (typeof id !== 'string' || !/^[a-zA-Z0-9]{6}$/.test(id)) return;
    if (detail.type === 'open') { popupIds.add(id); emit('klaviyo-popup', id, 'shown'); }
    if (detail.type === 'submit' && popupIds.has(id)) emit('klaviyo-popup', id, 'submitted');
    // embedOpen and metadata (which may include email/phone) are deliberately ignored.
  });
  function start() {
    if (!allowed()) return;
    sessions = read();
    Object.keys(sessions).forEach(function (slot) { if (Date.now() - sessions[slot].start > 86400000) delete sessions[slot]; });
    if (!observer) observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!allowed() || !entry.isIntersecting || entry.intersectionRatio < 0.5 || !visible(entry.target)) return;
        var id = variant(entry.target);
        if (id) emit(id, '', 'shown'); else if (target(entry.target)) { if (window.WynchJourneysV1) window.WynchJourneysV1.blockShown(); emit('quiz-cta', target(entry.target), 'shown'); }
      });
    }, { threshold: [0.5] });
    discover(); quizProgress();
  }
  var scheduled = false;
  new MutationObserver(function () {
    if (scheduled || !allowed()) return;
    scheduled = true; requestAnimationFrame(function () { scheduled = false; discover(); quizProgress(); });
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'style', 'class', 'data-art-direction-resolved'] });
  document.addEventListener('quiz:finished', function () { quizProgress('finished'); });
  document.addEventListener('visitorConsentCollected', function () {
    if (allowed()) start();
    else { sessions = {}; popupIds.clear(); if (observer) observer.disconnect(); observed = new WeakSet(); try { localStorage.removeItem(key); sessionStorage.removeItem(ctaKey); } catch (_) {} }
  });
  document.addEventListener('visibilitychange', function () { if (allowed()) { if (observer) { observer.disconnect(); observed = new WeakSet(); } discover(); quizProgress(); } });
  var attempts = 0;
  (function ready() { start(); if ((!window.Shopify || !Shopify.customerPrivacy) && ++attempts < 40) setTimeout(ready, 250); })();
})();
